import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CatButton } from "blocks-nextjs/blocks-react/components/Button/Button";
import { CatContextualMenu } from "blocks-nextjs/blocks-react/components/ContextualMenu/ContextualMenu";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconArrowDown } from "blocks-nextjs/blocks-react/components/Icons/ArrowDown/ArrowDown";
import { CatIconArrowUp } from "blocks-nextjs/blocks-react/components/Icons/ArrowUp/ArrowUp";
import { CatIconWarningDiamondFilled } from "blocks-nextjs/blocks-react/components/Icons/WarningDiamondFilled/WarningDiamondFilled";
import { CatIconWarningTriangleFilled } from "blocks-nextjs/blocks-react/components/Icons/WarningTriangleFilled/WarningTriangleFilled";
import { CatList } from "blocks-nextjs/blocks-react/components/List/List";
import { CatListItem } from "blocks-nextjs/blocks-react/components/ListItem/ListItem";
import { CatLoadingIndicator } from "blocks-nextjs/blocks-react/components/LoadingIndicator/LoadingIndicator";
import { CatPagination } from "blocks-nextjs/blocks-react/components/Pagination/Pagination";
// import { CatStatusIndicator } from "blocks-nextjs/blocks-react/components/StatusIndicator/StatusIndicator";
import { CatTable } from "blocks-nextjs/blocks-react/components/Table/Table";
import { CatTableBody } from "blocks-nextjs/blocks-react/components/TableBody/TableBody";
import { CatTableCell } from "blocks-nextjs/blocks-react/components/TableCell/TableCell";
import { CatTableHeader } from "blocks-nextjs/blocks-react/components/TableHeader/TableHeader";
import { CatTableHeaderCell } from "blocks-nextjs/blocks-react/components/TableHeaderCell/TableHeaderCell";
import { CatTableRow } from "blocks-nextjs/blocks-react/components/TableRow/TableRow";
import { format } from "date-fns";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { isTimeOnlyTimestamp } from "../../pages/Projects/ProjectDetails.helper";
// import { getLocalTime } from "../../pages/Projects/ProjectDetails.helper";
import { useAssetFaultsCountQuery, useAssetFaultsSearchQuery } from "../../services/query/assetFaults.query";
import { useProjectChargerFaultsCountQuery, useProjectChargerFaultsListQuery } from "../../services/query/eflow-charger-dashboard-api.query";
import { PROJECT_NAME_MALAGA } from "../../shared/constants";
import { getTimezoneAbbr as getSharedTimezoneAbbr } from "../../shared/helper";
import useAppConfigStore from "../../store/useAppConfigStore";
import { AssetFaultTypePropertyForFiltering } from "../../swagger/caasService-v1/models/AssetFaultTypePropertyForFiltering";
import { FaultPropertiesForFiltering } from "../../swagger/caasService-v1/models/FaultPropertiesForFiltering";
import { PropertiesForFiltering } from "../../swagger/caasService-v1/models/PropertiesForFiltering";
import { RangeFilterType } from "../../swagger/caasService-v1/models/RangeFilterType";
import { safeFormatInTimeZone } from "../../utils/dateFormatter";
const Alerts = (props) => {
    const { assetId, assetSourceType, chargerFromDate, chargerToDate, isRefreshComponent, last24hrsAlertsCount, methanolFromDate, methanolToDate, projectId, projectName, refetchKey, timezone } = props;
    const [internalSortOrder, setInternalSortOrder] = useState("DESC");
    const [sortKey, setSortKey] = useState(0);
    const alertsSortOrder = props.sortOrder ?? internalSortOrder;
    const setAlertsSortOrder = (order) => {
        setInternalSortOrder(order);
        setSortKey((prev) => prev + 1);
        props.onSortOrderChange?.(order);
    };
    const [faultsDataOnPage, setFaultsDataOnPage] = useState({});
    const [pageNumber, setPageNumber] = useState(1);
    const faultsPerPage = 5;
    const isMethanolReformer = assetSourceType === "methanol_reformer";
    const { appConfig } = useAppConfigStore((state) => ({
        appConfig: state.appConfig
    }));
    // Feature flag interpretation: When TRUE, API sends properly formatted timestamps (new behavior)
    // When FALSE, legacy API requires manual timestamp formatting (old behavior)
    const useLegacyTimestampHandling = !appConfig?.release_1_1?.showCestTimezone;
    const filterFields = [
        { propertyName: AssetFaultTypePropertyForFiltering.ASSET_ID, type: "stringEquals" },
        { propertyName: FaultPropertiesForFiltering.FAULT_REPORTED_TIME, type: "timeRange" },
        { propertyName: AssetFaultTypePropertyForFiltering.PROJECT_ID, type: "stringEquals" }
    ];
    const prepareRequestBodyFilters = (isLast24hrsCount) => {
        let timeFilterValue;
        //converting time into cest
        // const timeoffset = +new Date(getLocalTime(new Date().toISOString(), offset));
        //converting time into utc
        const timeoffset = Date.parse(new Date().toISOString());
        if (isLast24hrsCount) {
            timeFilterValue = new Date(timeoffset - 24 * 60 * 60 * 1000).toISOString();
        }
        else {
            timeFilterValue = new Date(timeoffset - 10 * 24 * 60 * 60 * 1000).toISOString();
        }
        // When showCestTimezone is TRUE, replace "Z" with timezone offset
        // Example: "2025-12-11T21:27:02.981Z" → "2025-12-11T21:27:02.981+01:00"
        if (!useLegacyTimestampHandling) {
            // Get the timezone offset for Amsterdam (CEST is UTC+2, CET is UTC+1)
            // Create a date in the project timezone to determine the current offset
            const date = new Date(timeFilterValue);
            const formatter = new Intl.DateTimeFormat("en-US", {
                timeZone: timezone || "Europe/Amsterdam",
                timeZoneName: "longOffset"
            });
            // Extract offset from formatted string (e.g., "GMT+01:00" or "GMT+02:00")
            const parts = formatter.formatToParts(date);
            const offsetPart = parts.find((part) => part.type === "timeZoneName");
            let offset = "+01:00"; // Default to CET
            if (offsetPart?.value) {
                const match = offsetPart.value.match(/GMT([+-]\d{2}:\d{2})/);
                if (match) {
                    offset = match[1];
                }
            }
            // Replace "Z" with the timezone offset
            timeFilterValue = timeFilterValue.replace(/Z$/, offset);
        }
        return filterFields.map((filterField) => {
            if (filterField.type === "stringEquals") {
                return {
                    isCaseSensitive: true,
                    propertyName: filterField.propertyName,
                    type: filterField.type,
                    values: [filterField.propertyName === "assetId" ? assetId : projectId]
                };
            }
            else if (filterField.type === "timeRange") {
                return {
                    propertyName: filterField.propertyName,
                    range: {
                        includeLeft: true,
                        left: timeFilterValue
                    },
                    type: filterField.type
                };
            }
        });
    };
    const searchRequestBody = useMemo(() => ({
        filters: prepareRequestBodyFilters(false)
    }), [assetId, projectId, timezone, useLegacyTimestampHandling]);
    const last24hrsCountRequestBody = useMemo(() => ({
        filters: prepareRequestBodyFilters(true)
    }), [assetId, projectId, timezone, useLegacyTimestampHandling]);
    const isCharger = assetSourceType === "charger";
    const isEss = assetSourceType === "ess";
    // Charger, methanol reformer, and ESS share the same alternate (div-based) layout
    const useAlternateLayout = isMethanolReformer || isCharger || isEss;
    const isQueryEnabled = isRefreshComponent && !isCharger && !isMethanolReformer;
    const hasChargerDates = Boolean(chargerFromDate && chargerToDate);
    const isChargerQueryEnabled = isRefreshComponent && isCharger && hasChargerDates;
    const hasMethanolDates = Boolean(methanolFromDate && methanolToDate);
    const isMethanolQueryEnabled = isRefreshComponent && isMethanolReformer && hasMethanolDates;
    const { data: searchResponse, error: searchError, isError: isSearchError, isLoading: isSearchLoading } = useAssetFaultsSearchQuery(searchRequestBody, {
        enabled: isQueryEnabled,
        limit: faultsPerPage,
        orderBy: [alertsSortOrder],
        skip: faultsPerPage * (pageNumber - 1) || 0,
        sortBy: ["timestamp"],
        sortKey
    });
    const { data: last24hrsCountResponse } = useAssetFaultsCountQuery(last24hrsCountRequestBody, {
        enabled: isQueryEnabled
    });
    const { data: totalCountResponse } = useAssetFaultsCountQuery(searchRequestBody, {
        enabled: isQueryEnabled
    });
    // --- Charger faults API (for assetSourceType === "charger") ---
    // Only build the time range filter when both dates are valid; queries are disabled otherwise via isChargerQueryEnabled
    const chargerSearchRequest = useMemo(() => ({
        filters: hasChargerDates
            ? [
                {
                    propertyName: PropertiesForFiltering.TIMESTAMP,
                    range: { left: chargerFromDate, right: chargerToDate },
                    type: RangeFilterType.TIME_RANGE
                }
            ]
            : []
    }), [chargerFromDate, chargerToDate, hasChargerDates]);
    const chargerFaultsParams = useMemo(() => ({
        assetId,
        limit: String(faultsPerPage),
        orderBy: alertsSortOrder,
        projectId,
        skip: String(faultsPerPage * (pageNumber - 1) || 0),
        sortBy: "timestamp"
    }), [assetId, projectId, alertsSortOrder, pageNumber]);
    // Build a today-only request body for the charger 24h count query
    const chargerLast24hrsRequestBody = useMemo(() => {
        if (!isCharger)
            return { filters: [] };
        // Get timezone offset suffix from Intl (e.g. "+02:00") — independent of chargerToDate
        const now = new Date();
        const projectTz = timezone || "Europe/Amsterdam";
        const offsetParts = new Intl.DateTimeFormat("en-US", {
            hour: "2-digit",
            hour12: false,
            minute: "2-digit",
            timeZone: projectTz,
            timeZoneName: "longOffset"
        }).formatToParts(now);
        const tzNamePart = offsetParts.find((p) => p.type === "timeZoneName")?.value || "+00:00";
        const tzSuffix = tzNamePart.replace("GMT", "") || "+00:00";
        // Determine "today" in the project timezone
        const dateParts = new Intl.DateTimeFormat("en-US", {
            day: "2-digit",
            month: "2-digit",
            timeZone: projectTz,
            year: "numeric"
        }).formatToParts(now);
        const year = dateParts.find((p) => p.type === "year")?.value ?? String(now.getFullYear());
        const month = dateParts.find((p) => p.type === "month")?.value ?? String(now.getMonth() + 1).padStart(2, "0");
        const day = dateParts.find((p) => p.type === "day")?.value ?? String(now.getDate()).padStart(2, "0");
        const left24h = `${year}-${month}-${day}T00:00:00.000${tzSuffix}`;
        const right24h = `${year}-${month}-${day}T23:59:59.999${tzSuffix}`;
        return {
            filters: [
                {
                    propertyName: PropertiesForFiltering.TIMESTAMP,
                    range: { left: left24h, right: right24h },
                    type: RangeFilterType.TIME_RANGE
                }
            ]
        };
    }, [timezone, isCharger]);
    const { data: chargerSearchResponse, error: chargerSearchError, isError: isChargerSearchError, isLoading: isChargerSearchLoading } = useProjectChargerFaultsListQuery(chargerFaultsParams, chargerSearchRequest, {
        enabled: isChargerQueryEnabled,
        refetchKey: (refetchKey || 0) * 1000 + sortKey
    });
    const { data: chargerLast24hrsCountResponse } = useProjectChargerFaultsCountQuery({ assetId, projectId }, chargerLast24hrsRequestBody, { enabled: isChargerQueryEnabled, refetchKey });
    const { data: chargerTotalCountResponse } = useProjectChargerFaultsCountQuery({ assetId, projectId }, chargerSearchRequest, { enabled: isChargerQueryEnabled, refetchKey });
    // Normalize charger faults response to common shape
    const normalizedChargerResponse = useMemo(() => {
        if (!chargerSearchResponse?.faultCodes)
            return undefined;
        return {
            faults: chargerSearchResponse.faultCodes.map((fault) => ({
                assetId: fault.chargerId || assetId,
                faultDescription: fault.errorInfo || fault.vendorErrorDescription || fault.errorCode || "",
                severity: { name: "", value: 0 },
                timestamp: fault.timestamp || ""
            }))
        };
    }, [chargerSearchResponse, assetId]);
    // --- Methanol Reformer faults API ---
    // Same three filters as ESS/machines: assetId, faultReportedTime (range), projectId
    const methanolSearchRequestBody = useMemo(() => ({
        filters: hasMethanolDates
            ? [
                {
                    isCaseSensitive: true,
                    propertyName: AssetFaultTypePropertyForFiltering.ASSET_ID,
                    type: "stringEquals",
                    values: [assetId]
                },
                {
                    propertyName: FaultPropertiesForFiltering.FAULT_REPORTED_TIME,
                    range: { left: methanolFromDate, right: methanolToDate },
                    type: "timeRange"
                },
                {
                    isCaseSensitive: true,
                    propertyName: AssetFaultTypePropertyForFiltering.PROJECT_ID,
                    type: "stringEquals",
                    values: [projectId]
                }
            ]
            : []
    }), [assetId, projectId, methanolFromDate, methanolToDate, hasMethanolDates]);
    const methanolLast24hrsRequestBody = useMemo(() => {
        if (!hasMethanolDates)
            return { filters: [] };
        // Extract the project timezone offset suffix from methanolToDate (e.g. "+02:00")
        const tzOffsetMatch = methanolToDate?.match(/([+-]\d{2}:\d{2})$/);
        const tzSuffix = tzOffsetMatch ? tzOffsetMatch[1] : "+00:00";
        // Determine "today" in the project timezone by formatting the current moment
        // using Intl.DateTimeFormat — this gives the correct local date regardless of
        // what timezone the browser is running in.
        const now = new Date();
        const projectTz = timezone || "Europe/Amsterdam";
        const dateParts = new Intl.DateTimeFormat("en-US", {
            day: "2-digit",
            month: "2-digit",
            timeZone: projectTz,
            year: "numeric"
        }).formatToParts(now);
        const year = dateParts.find((p) => p.type === "year")?.value ?? String(now.getFullYear());
        const month = dateParts.find((p) => p.type === "month")?.value ?? String(now.getMonth() + 1).padStart(2, "0");
        const day = dateParts.find((p) => p.type === "day")?.value ?? String(now.getDate()).padStart(2, "0");
        // Build start-of-today and end-of-today in project TZ — matching image 3 standard:
        // left  = "2026-04-12T00:00:00.000+02:00"
        // right = "2026-04-12T23:59:59.999+02:00"
        const left24h = `${year}-${month}-${day}T00:00:00.000${tzSuffix}`;
        const right24h = `${year}-${month}-${day}T23:59:59.999${tzSuffix}`;
        return {
            filters: [
                {
                    isCaseSensitive: true,
                    propertyName: AssetFaultTypePropertyForFiltering.ASSET_ID,
                    type: "stringEquals",
                    values: [assetId]
                },
                {
                    propertyName: FaultPropertiesForFiltering.FAULT_REPORTED_TIME,
                    range: { left: left24h, right: right24h },
                    type: "timeRange"
                },
                {
                    isCaseSensitive: true,
                    propertyName: AssetFaultTypePropertyForFiltering.PROJECT_ID,
                    type: "stringEquals",
                    values: [projectId]
                }
            ]
        };
    }, [assetId, projectId, methanolToDate, timezone, hasMethanolDates]);
    const { data: methanolSearchResponse, error: methanolSearchError, isError: isMethanolSearchError, isLoading: isMethanolSearchLoading } = useAssetFaultsSearchQuery(methanolSearchRequestBody, {
        enabled: isMethanolQueryEnabled,
        limit: faultsPerPage,
        orderBy: [alertsSortOrder],
        skip: faultsPerPage * (pageNumber - 1) || 0,
        sortBy: ["timestamp"],
        sortKey
    });
    const { data: methanolLast24hrsCountResponse } = useAssetFaultsCountQuery(methanolLast24hrsRequestBody, {
        enabled: isMethanolQueryEnabled
    });
    const { data: methanolTotalCountResponse } = useAssetFaultsCountQuery(methanolSearchRequestBody, {
        enabled: isMethanolQueryEnabled
    });
    // Merge charger, methanol, and ESS/machine faults into common variables
    const effectiveSearchResponse = isCharger
        ? normalizedChargerResponse
        : isMethanolReformer
            ? methanolSearchResponse
            : searchResponse;
    const effectiveSearchError = isCharger
        ? chargerSearchError
        : isMethanolReformer
            ? methanolSearchError
            : searchError;
    const isEffectiveSearchError = isCharger
        ? isChargerSearchError
        : isMethanolReformer
            ? isMethanolSearchError
            : isSearchError;
    const effectiveLast24hrsCount = isCharger
        ? chargerLast24hrsCountResponse
        : isMethanolReformer
            ? methanolLast24hrsCountResponse
            : last24hrsCountResponse;
    const assetFaultsCount = (isCharger
        ? chargerTotalCountResponse
        : isMethanolReformer
            ? methanolTotalCountResponse
            : totalCountResponse) || { count: 0 };
    const isLoading = isCharger
        ? isChargerSearchLoading && isChargerQueryEnabled
        : isMethanolReformer
            ? isMethanolSearchLoading && isMethanolQueryEnabled
            : isSearchLoading && isQueryEnabled;
    // Handle search response updates
    useEffect(() => {
        if (effectiveSearchResponse) {
            const needsTimestampProcessing = !isCharger &&
                ((useLegacyTimestampHandling && projectName === PROJECT_NAME_MALAGA) || !useLegacyTimestampHandling);
            const data = needsTimestampProcessing
                ? handleTimestampInData(effectiveSearchResponse)
                : effectiveSearchResponse;
            setFaultsDataOnPage((prev) => ({ ...prev, [pageNumber]: data }));
            if (effectiveSearchResponse?.faults?.length > 0) {
                props.isDataAvailableForAsset(true);
            }
            else {
                // Explicitly close accordion when API returns empty results
                props.isDataAvailableForAsset(false);
            }
        }
    }, [effectiveSearchResponse]);
    // Handle search error
    useEffect(() => {
        if (isEffectiveSearchError) {
            props.isDataAvailableForAsset(false);
        }
    }, [isEffectiveSearchError]);
    // Handle last 24hrs count response
    useEffect(() => {
        if (effectiveLast24hrsCount) {
            last24hrsAlertsCount(effectiveLast24hrsCount?.count || 0);
        }
    }, [effectiveLast24hrsCount]);
    // Reset cached page data when charger date range changes to prevent stale data display
    useEffect(() => {
        setPageNumber(1);
        setFaultsDataOnPage({});
    }, [chargerFromDate, chargerToDate]);
    // Enterprise sort behavior (ESS only): when the sort order changes, jump back to the
    // first page so the user lands at the top of the newly ordered list. Scoped to the ESS
    // drawer so charger/methanol/machine pagination is unaffected; the backend re-queries via
    // the orderBy query key and the response effect re-stores the page. Skip the initial mount.
    const isInitialSortRun = useRef(true);
    useEffect(() => {
        if (isInitialSortRun.current) {
            isInitialSortRun.current = false;
            return;
        }
        if (isEss)
            setPageNumber(1);
    }, [alertsSortOrder, isEss]);
    useEffect(() => {
        if (!isRefreshComponent) {
            setInternalSortOrder("DESC");
            props.onSortOrderChange?.("DESC");
            setPageNumber(1);
            setFaultsDataOnPage({});
        }
        else if (effectiveSearchResponse) {
            // Re-populate from cached query data when drawer reopens
            const needsTimestampProcessing = !isCharger &&
                ((useLegacyTimestampHandling && projectName === PROJECT_NAME_MALAGA) || !useLegacyTimestampHandling);
            const data = needsTimestampProcessing
                ? handleTimestampInData(effectiveSearchResponse)
                : effectiveSearchResponse;
            setFaultsDataOnPage({ 1: data });
            if (effectiveSearchResponse?.faults?.length > 0) {
                props.isDataAvailableForAsset(true);
            }
            if (effectiveLast24hrsCount) {
                last24hrsAlertsCount(effectiveLast24hrsCount?.count || 0);
            }
        }
    }, [assetId, isRefreshComponent]);
    useEffect(() => {
        //Wrapping this in setTimeout without any delay helps us finding the shadow-root element
        setTimeout(() => {
            //Finding the shadow-root element to modify the styles of the pagenation dropdown
            const alertsPaginationDropDown = document
                .querySelector(".alerts-pagination")
                ?.shadowRoot.querySelector(".cat-c-pagination-dropdown");
            alertsPaginationDropDown?.setAttribute("style", "display:none");
            const itemPage = document
                .querySelector(".alerts-pagination")
                ?.shadowRoot.querySelectorAll(".cat-c-pagination-item-page");
            itemPage?.forEach((pageElement) => {
                const pageBtnElement = pageElement?.shadowRoot.querySelector(".cat-c-pagination__item-button");
                if (pageBtnElement?.hasAttribute("currentstateindicator")) {
                    const pageBtn = pageBtnElement?.shadowRoot.querySelector(".cat-c-button--ghost");
                    pageBtn?.setAttribute("style", "background-color: #00447a; color: #FFFFFF; border-radius: 50px; border: 1px solid #00447a;padding: 5px 10px;");
                }
            });
        });
    });
    // Handling timestamp in data to ensure it has the correct format
    // This is used ONLY when the feature flag is OFF for legacy API responses
    // When feature flag is ON, API sends properly formatted timestamps without needing "T" or "Z" appended
    const handleTimestampInData = (assetFaultsData) => {
        const formattedFaultsTimeStampData = assetFaultsData?.faults?.map((data) => {
            let timestamp = data.timestamp || "";
            // Handle time-only format (e.g., "05:00:00") - get today's date in PROJECT timezone
            if (isTimeOnlyTimestamp(timestamp)) {
                const todayInProjectTz = timezone
                    ? safeFormatInTimeZone(new Date(), timezone, "yyyy-MM-dd")
                    : new Date().toISOString().split("T")[0];
                timestamp = todayInProjectTz + "T" + timestamp;
            }
            else if (!timestamp.includes("T")) {
                // Fallback: For timestamps without "T" but not time-only format
                const todayPrefix = new Date().toISOString().split("T")[0] + "T";
                timestamp = todayPrefix + timestamp;
            }
            // When showCestTimezone is TRUE: Remove "Z" to display CEST time as-is
            // When showCestTimezone is FALSE: Add "Z" for UTC timezone parsing
            if (!useLegacyTimestampHandling) {
                // New mode: Remove "Z" if present (e.g., "2025-12-11T21:27:02.981Z" → "2025-12-11T21:27:02.981")
                timestamp = timestamp.replace(/Z$/, "");
            }
            else {
                // Legacy mode: Add "Z" if not present for UTC timezone
                if (!timestamp.includes("Z")) {
                    timestamp = timestamp + "Z";
                }
            }
            return {
                ...data,
                timestamp
            };
        });
        return {
            ...assetFaultsData,
            faults: formattedFaultsTimeStampData
        };
    };
    const getTimezoneAbbr = (timestamp) => {
        // For timestamps without "Z", they are already in project timezone
        // We need to determine the DST status based on the date, not the time
        if (timestamp && !timestamp.endsWith("Z")) {
            // Parse date components: "2025-12-18T04:00:00"
            const [datePart] = timestamp.split("T");
            const [year, month, day] = datePart.split("-");
            // Create an ISO string for noon on that date in UTC, then use shared helper
            // This ensures we check DST for the correct date
            const noonUtc = `${year}-${month}-${day}T12:00:00Z`;
            return getSharedTimezoneAbbr(timezone, noonUtc);
        }
        // For timestamps with "Z" or no timestamp, use shared helper directly
        return getSharedTimezoneAbbr(timezone, timestamp);
    };
    // Format timestamps for alert/fault display, including in populateFaultsData()
    const getFormattedTimestamp = useCallback((timestamp) => {
        if (timestamp) {
            try {
                // When showCestTimezone is TRUE: API sends timestamps without "Z" already in project timezone
                // When showCestTimezone is FALSE: API sends UTC timestamps with "Z"
                if (!useLegacyTimestampHandling && !timestamp.endsWith("Z")) {
                    // API sends timestamp already in project timezone (e.g., "2024-01-15T10:00:00" means 10:00 AM project time)
                    // Parse and display the wall-clock time components directly
                    const [datePart, timePart] = timestamp.split("T");
                    const [year, month, day] = datePart.split("-");
                    const [hour, minute] = timePart.split(":");
                    // Format: dd MMM yyyy, HH:mm
                    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
                    const monthName = format(date, "MMM");
                    return `${day} ${monthName} ${year}, ${hour}:${minute}`;
                }
                // Legacy mode or UTC timestamps: Parse and format normally
                const date = new Date(timestamp);
                // Check if the date is valid
                if (isNaN(date.getTime())) {
                    return "";
                }
                // Format using date-fns for consistent output
                return format(date, "dd MMM yyyy, HH:mm");
            }
            catch (error) {
                console.error("Error formatting timestamp:", timestamp, error);
                return "";
            }
        }
        return "";
    }, [useLegacyTimestampHandling, timezone]);
    const populateFaultsData = () => {
        const faults = faultsDataOnPage?.[pageNumber]?.faults;
        return isEffectiveSearchError ? (_jsx("div", { className: "flex justify-center items-center h-[100px]", "data-test": "alerts-error", children: effectiveSearchError?.response?.data?.description || "Error loading faults" })) : (faults?.map((fault, index) => {
            const formattedTimestamp = getFormattedTimestamp(fault.timestamp);
            const timezoneAbbr = timezone ? getTimezoneAbbr(fault.timestamp) : "";
            const recordNumber = (pageNumber - 1) * faultsPerPage + (index + 1);
            return (_jsxs(CatTableRow, { "data-test": `fault-row-${index}`, children: [_jsx(CatTableCell, { "data-test": `fault-cell-description-${index}`, children: _jsxs("div", { className: "flex flex-column items-center ml-[15px] ", children: [_jsx("span", { className: "mr-[15px] min-w-[15px] text-right", "data-test": `fault-record-number-${index}`, children: recordNumber }), _jsx("span", { "data-test": `fault-description-text-${index}`, children: fault.faultDescription })] }) }), _jsx(CatTableCell, { "data-test": `fault-cell-timestamp-${index}`, children: _jsx("div", { className: "flex justify-end items-center h-[32px] gap-8", children: _jsxs("span", { className: "text-right", "data-test": `fault-timestamp-${index}`, children: [formattedTimestamp, " ", timezoneAbbr] }) }) })] }, index));
        }));
    };
    const updateSortOrder = (order) => {
        setAlertsSortOrder(order);
    };
    const hasNoFaultsOnCurrentPage = (faultsDataOnPage?.[pageNumber]?.faults?.length ?? 0) === 0;
    const essNoAlertsState = (_jsxs("div", { className: "flex flex-col items-center justify-center w-full text-center px-6 py-10 gap-2.5 h-[360px]", "data-test": "ess-alerts-empty-state", children: [_jsx("div", { "aria-hidden": "true", className: "flex items-center justify-center w-20 h-20 rounded-full bg-gray-100", "data-test": "ess-alerts-empty-state-icon-circle", children: _jsx(CatIconWarningTriangleFilled, { "data-test": "ess-alerts-empty-state-icon", size: "xl" }) }), _jsx("h3", { className: "w-full max-w-[292px] text-xl font-bold text-gray-900 text-center", "data-test": "ess-alerts-empty-state-title", children: "No Alerts" }), _jsx("p", { className: "w-full max-w-[420px] text-sm font-semibold text-[#3F3F3F] text-center", "data-test": "ess-alerts-empty-state-description", children: "No alerts found for this asset in the past 24 hours" })] }));
    return (_jsxs("div", { className: "flex flex-col gap-3", "data-test": "alerts-container", children: [isLoading && (_jsx("div", { className: "flex justify-center items-center h-[353px]", "data-test": "alerts-loading", children: _jsx(CatLoadingIndicator, {}) })), !isLoading && (_jsxs(React.Fragment, { children: [useAlternateLayout ? (_jsx("div", { className: `${isEss ? "h-[348px]" : "h-[360px]"} overflow-auto`, "data-test": "alt-alerts-list", children: isEss && (isEffectiveSearchError || hasNoFaultsOnCurrentPage) ? (essNoAlertsState) : isEffectiveSearchError ? (_jsx("div", { className: "flex justify-center items-center h-[100px]", "data-test": "alt-alerts-error", children: "No data available" })) : (faultsDataOnPage?.[pageNumber]?.faults?.map((fault, index) => {
                            const timezoneAbbr = timezone ? getTimezoneAbbr(fault.timestamp) : "";
                            const faults = faultsDataOnPage?.[pageNumber]?.faults;
                            const isLastRow = index === faults.length - 1;
                            return (_jsxs("div", { className: "flex flex-col", "data-test": `alt-fault-row-${index}`, children: [_jsx("div", { className: "mx-4 border-t border-[#CCCCCC]", "data-test": `alt-fault-row-separator-top-${index}` }), _jsxs("div", { className: "flex items-center justify-between px-7 pt-[4px] pb-[4px] min-h-[68px]", "data-test": `alt-fault-row-content-${index}`, children: [_jsxs("div", { className: "flex items-center gap-5", "data-test": `alt-fault-row-left-${index}`, children: [isEss && fault.assetId && (_jsx("span", { className: "whitespace-nowrap font-['Noto_Sans'] text-[14px] font-normal leading-[140%] tracking-[0px] align-middle text-[#000000]", "data-test": `alt-fault-id-${index}`, children: fault.assetId })), _jsx("span", { className: isEss
                                                            ? "font-['Noto_Sans'] text-[14px] font-normal leading-[140%] tracking-[0px] align-middle text-[#000000]"
                                                            : undefined, "data-test": `alt-fault-description-${index}`, children: fault.faultDescription })] }), _jsxs("div", { className: "flex items-center flex-shrink-0 ml-4 gap-8", "data-test": `alt-fault-row-right-${index}`, children: [_jsx(CatIconWarningDiamondFilled, { className: "text-[#990000] w-[24px] h-[24px] flex-shrink-0", "data-test": `fault-severity-icon-${index}`, style: isEss
                                                            ? {
                                                                "--cat-icon-height": "24px",
                                                                "--cat-icon-width": "24px"
                                                            }
                                                            : undefined }), _jsxs("div", { className: isEss
                                                            ? "flex flex-col items-end text-right w-[110px] font-['Noto_Sans'] text-[14px] font-normal leading-[140%] tracking-[0px] align-middle text-[#000000]"
                                                            : "flex flex-col items-end text-right leading-tight text-sm w-[110px]", "data-test": `alt-fault-timestamp-${index}`, children: [_jsx("span", { "data-test": `alt-fault-date-${index}`, children: format(new Date(fault.timestamp), "MMM dd, yyyy;").toUpperCase() }), _jsxs("span", { "data-test": `alt-fault-time-${index}`, children: [format(new Date(fault.timestamp), "h:mm aa"), " ", timezoneAbbr] })] })] })] }), isLastRow && (_jsx("div", { className: "mx-4 border-t border-[#CCCCCC]", "data-test": `alt-fault-row-separator-bottom-${index}` }))] }, index));
                        })) })) : (_jsx("div", { className: "h-[290px] overflow-auto", "data-test": "alerts-table-wrapper", children: _jsxs(CatTable, { arialabel: "Default Table", "data-test": "alerts", children: [_jsx("div", { slot: "caption", children: "Default Table Description" }), _jsx(CatTableHeader, { "data-test": "cat-table-header", isFrozen: true, children: _jsxs(CatTableRow, { children: [_jsx(CatTableHeaderCell, { "data-test": "alerts-header-title", children: _jsx("div", { className: "flex flex-column items-center", children: _jsx(CatHeading, { className: "mr-[10px]", "data-test": "alert-header-text", variant: "title", children: _jsx("div", { className: "text-sm", children: "Alert Description" }) }) }) }), _jsx(CatTableHeaderCell, { "data-test": "sort-header-title", children: _jsx("div", { className: "flex justify-end items-center h-[32px]", children: _jsx("div", { className: "flex items-center list-item-link", children: faultsDataOnPage?.[pageNumber]?.faults?.length > 0 ? (_jsxs(CatContextualMenu
                                                        // className="cat-u-margin-left-sm"
                                                        , { "data-test": "soc-context-menu", position: "bottom", children: [_jsx(CatButton, { slot: "trigger", variant: "ghost", children: _jsx("div", { className: "flex items-center text text-black", children: alertsSortOrder === "DESC" ? (_jsxs(_Fragment, { children: [_jsx(CatIconArrowDown, { className: "items-end self-center height-15px mr-1" }), _jsx("span", { children: "Sort" })] })) : (_jsxs(_Fragment, { children: [_jsx(CatIconArrowUp, { className: "items-end self-center height-15px mr-1" }), _jsx("span", { children: "Sort" })] })) }) }), _jsx("div", { className: "list-item-link", children: _jsxs(CatList, { "data-test": "context-menu-items", slot: "items", children: [_jsx(CatListItem, { "data-test": "sort-by-newest", onBlSelect: () => {
                                                                                    updateSortOrder("DESC");
                                                                                }, children: "Sort by Newest" }), _jsx(CatListItem, { "data-test": "sort-by-earliest", onBlSelect: () => {
                                                                                    updateSortOrder("ASC");
                                                                                }, children: "Sort by Earliest" })] }) })] })) : (_jsx("div", { className: "flex items-center text text-black", "data-test": "alerts-sort-label", children: _jsx("span", { children: "Sort" }) })) }) }) })] }) }), _jsx(CatTableBody, { "data-test": "alerts-table-body", children: populateFaultsData() })] }) })), !isEffectiveSearchError && (_jsxs("div", { className: "flex justify-between items-center", "data-test": "alerts-footer", children: [_jsxs("div", { className: `w-1/3 ml-[15px] font-['Noto_Sans'] font-normal tracking-[0px] ${isEss
                                    ? "text-[12px] leading-[16px] text-[#666565]"
                                    : "text-[14px] leading-[140%] text-[#000000]"}`, "data-test": "alerts-total-count", children: [assetFaultsCount?.count || 0, " Total"] }), _jsx(CatPagination, { arialabel: "Pagination footer", className: "alerts-pagination", currentItem: pageNumber, "data-test": "alerts-pagination", hidePageSize: true, onBlPageChange: (event) => {
                                    const page = event.detail.pageNumber;
                                    setPageNumber(page);
                                }, pageSize: faultsPerPage, slot: "footer", totalRecords: assetFaultsCount?.count || 0, variant: isEss ? "in-page" : undefined }, pageNumber)] }))] }))] }));
};
export default Alerts;
